function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.315 0H34.203c-6.852 0-12.425 5.574-12.425 12.425v2.093h-2.093c-6.852 0-12.425 5.574-12.425 12.425v50.632C7.259 84.426 12.833 90 19.685 90h36.112c6.852 0 12.426-5.574 12.426-12.425v-2.094h2.093c6.852 0 12.426-5.574 12.426-12.425V12.425C82.741 5.574 77.167 0 70.315 0zm-6.092 77.575c0 4.646-3.78 8.425-8.426 8.425H19.685c-4.646 0-8.425-3.779-8.425-8.425V26.943c0-4.646 3.78-8.425 8.425-8.425h2.093v44.538c0 6.851 5.574 12.425 12.425 12.425h30.02v2.094zm14.518-14.518c0 4.646-3.78 8.425-8.426 8.425H34.202c-4.646 0-8.425-3.779-8.425-8.425V12.426C25.778 7.78 29.558 4 34.203 4h36.112c4.646 0 8.426 3.78 8.426 8.425v50.632z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#000",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(2.81 0 0 2.81 1.407 1.407)"
  })));
};
export default SvgCopy;